import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FormRadioGroupInput from "./form/formRadioGroupInput.component";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { stateProps } from "../types";
import { changeBoardCertified } from "../actions/index";

const BoardCertified: React.FC = () => {
  const dispatch = useDispatch();

  const items = ["Yes", "No"];

  const boardCertified = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.boardCertified
  );

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;
    dispatch(changeBoardCertified(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText
          number={"13"}
          title={"For Specializations, are you PGIM board certified?"}
          optional={"(Optional)"}
        />

        <FormRadioGroupInput
          onInputChange={onInputChange}
          value={boardCertified}
          items={items}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default BoardCertified;
